import { useMemo, useState, type ReactNode } from 'react';
import { BillingModalsContext, type CheckoutVariant } from '@/hook';
import { CheckoutModal } from './CheckoutModal';
import { PlanModal } from './PlanModal';

/** Hosts the plan and checkout modals once for the whole shell, so the nav
 * chip, the Home card, the Library band and the tier cards all open the same
 * two. Opening one closes the other; a closed modal mounts nothing. */
export function BillingModals({ children }: { children: ReactNode }) {
  const [planOpen, setPlanOpen] = useState(false);
  const [checkout, setCheckout] = useState<CheckoutVariant | null>(null);
  const api = useMemo(
    () => ({
      openPlan: () => {
        setCheckout(null);
        setPlanOpen(true);
      },
      openCheckout: (variant: CheckoutVariant) => {
        setPlanOpen(false);
        setCheckout(variant);
      },
    }),
    []
  );
  return (
    <BillingModalsContext.Provider value={api}>
      {children}
      {planOpen && <PlanModal onClose={() => setPlanOpen(false)} onCheckout={api.openCheckout} />}
      <CheckoutModal variant={checkout} onClose={() => setCheckout(null)} />
    </BillingModalsContext.Provider>
  );
}
